import { inject, Pipe, type PipeTransform } from '@angular/core';
import { LOCALE_CONFIG } from '@locale/locale-config.provider';
import { LocaleConfig } from '@locale/models/locale-config';
import { capitalize } from '@pixacare/shared';
import { formatDistanceToNowStrict } from 'date-fns';

@Pipe({
  name: 'relativeDate',
  standalone: true,
})
export class RelativeDatePipe implements PipeTransform {
  localeConfig = inject(LOCALE_CONFIG) as LocaleConfig;

  transform(date: Date | string | number): string {
    if (!date) {
      return '';
    }

    const d = new Date(date);

    const result = formatDistanceToNowStrict(d, {
      addSuffix: true,
      locale: this.localeConfig?.dateFnsConfig?.locale,
    });

    return capitalize(result);
  }
}
